import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "../../../interfaces/field.interface";
import { IonicModule, ModalController } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { TermoUsoPage } from "src/app/pages/termo-uso/termo-uso.page";
import { PrivacidadePage } from "src/app/pages/configuracao/privacidade/privacidade.page";
@Component({
  selector: "app-button",
  template: `
    <div class="custom-div">
      <p style="font-size: 0.9rem; text-align: -webkit-center;">
        {{ "Ao clicar em cadastrar, você concorda com nossos" | translate }}
        <a (click)="termoDeUso()">
          {{ "Termos de Uso" }}
        </a>
        {{ "e" | translate }}
        <a (click)="privacidade()"> {{ "Política de Privacidade" | translate }}. </a>
      </p>
    </div>
  `,
  styles: [
    `
      .custom-div {
        margin-bottom: 40px;
      }
    `,
  ],
  standalone: true,
  imports: [TranslateModule, IonicModule],
})
export class TermoComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {}

  async privacidade() {
    const modal = await this.modalCtrl.create({
      component: PrivacidadePage,
      componentProps: {
        isModal: true,
        idInstituicao: this.field.idInstituicao,
      },
    });
    await modal.present();
  }

  async termoDeUso() {
    const modal = await this.modalCtrl.create({
      component: TermoUsoPage,
      componentProps: {
        isModal: true,
        idInstituicao: this.field.idInstituicao,
      },
    });
    await modal.present();
  }
}
